import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

export const PeriodDialog = ({ open, onOpenChange, initial, title, onSave }) => {
  const [form, setForm] = useState({ name: '', start_date: '', end_date: '', submission_deadline: '' });

  useEffect(() => {
    if (open) {
      setForm({
        name: initial?.name || '',
        start_date: initial?.start_date || '',
        end_date: initial?.end_date || '',
        submission_deadline: initial?.submission_deadline || '',
      });
    }
  }, [open, initial]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const valid = form.name && form.start_date && form.end_date && form.submission_deadline;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[440px]" data-testid="period-dialog">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>Staff will see this period on their My Availability page.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 py-2">
          <div className="space-y-1.5">
            <label className="text-sm font-medium">Period name</label>
            <Input value={form.name} onChange={set('name')} placeholder="e.g. Aug 2 – Sep 5, 2026" data-testid="period-name-input" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5">
              <label className="text-sm font-medium">Start date</label>
              <Input type="date" value={form.start_date} onChange={set('start_date')} data-testid="period-start-input" />
            </div>
            <div className="space-y-1.5">
              <label className="text-sm font-medium">End date</label>
              <Input type="date" value={form.end_date} onChange={set('end_date')} data-testid="period-end-input" />
            </div>
          </div>
          <div className="space-y-1.5">
            <label className="text-sm font-medium">Submission deadline</label>
            <Input type="date" value={form.submission_deadline} onChange={set('submission_deadline')} data-testid="period-deadline-input" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={() => onSave(form)} disabled={!valid} data-testid="period-save-button">Save Period</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
